export const enum EGuidFluxoProcessoEtapa {
    'AnaliseDocumentacao' = 'd7484d96-6eda-4e3c-bee1-00957def98d7',
    'DefinicaoVendorList' = '90f7bde8-f514-4f2b-abe7-54e2cf475450',
    'EnvioDaCartaConvite' = '1a9d7312-07b3-4e04-b75d-c0d44e6a97d3',
    'AceiteOuDeclinio' = 'ff2290e8-88fb-421e-b87d-97089d1640ce',
    'VisitaTecnica' = 'c7784fad-13a2-4079-a8d5-6c235904224c',
    'EsclarecimentosTecnicosSolicitados' = 'fdd6c953-6156-48c9-9965-4331574b0f0e',
    'ConsolidacaoEsclarecimentosTecnicosEnvioAreaRequisitante' = '7e47ce82-ebc4-4d7f-af5f-8f548b8340da',
    'RecebimentoEsclarecimentosTecnicosAreaRequisitanteEnvioProponentes' = '4e17e0cf-301e-40a2-b4c6-12fdcc8dc23d',
    'RecebimentoPropostaTecnicasProponentes' = 'afdd88ab-2a88-4eaa-b8a3-45eb2f3a94ec',
    'AvaliacaoPropostasTecnicas' = 'dfed326d-5240-47ff-b048-a6010918d711',
    'EnvioPropostaTecnicaAreaRequisitante' = 'dcb54a44-f7df-4a0c-bed7-044198b73d8e',
    'ParecerTecnico' = '95baa97a-a5e6-44ed-a719-eaaf5f7bec29',
    'VerificacaoHomologacaoFornecedor' = '2a50a751-bcc3-4170-b68d-75b6e81eb68d',
    'SolicitacaoDDI' = 'f9a74513-bd6d-440a-81b8-58af02e73955',
    'SolicitacaoCONFIDE' = '9767e332-a7bd-4d12-8dfe-c8d42eaa84db',

    'RecebimentoFormularioDDIProponentesEnvioParaDPC' = '78e3d3bc-1c91-47bc-83fb-c5aba4173f13',
    'CadastroParecerDoDPCQuantoADDI' = '92d67971-c981-494a-b3b7-0d59023c9fb8',
    'SolicitacaoAvaliacaoFinanceira' = '290ea11a-ab3e-42ba-888e-e003ad21f6dc',
    'CadastroResultadoAvaliacaoFinanceira' = 'c9465de8-adc8-4d9f-96f4-4aff9367ff09',
    'RecebimentoPropostaComercial' = '3d6af65e-0f98-41d5-bc53-640641b4a94f',
    'AnalisePropostasComerciaisCadastroRodadasNegociacoes' = '672a422a-26b7-4826-837f-e0ab5aea6a60',
    'EnvioNegociacaoMinutaContratual' = 'e76715fc-1070-4b2b-9728-2822da90691c',
    'SolicitacaoChancelaGJMinuta' = 'd327a1ae-2bc0-4620-8a5d-65d932e9bd3c',
    'EnvioInformaçõesAdmContratosProvidenciarCES' = 'b7ec7231-eed4-4a7d-8a55-9e8f864bf5ea',
    'ElaboracaoaprovacaoRH' = '908dd87d-9cf7-4279-adbd-56d2feb6aa43',
    'GerarContratoPCSTotvs' = '01e2479a-6622-4830-b1b0-43e1be230407',
    'ConsolidacaoAnexosFinais' = 'ceaceae4-0e76-4e44-a6d7-2c08bbd4d901',
    'Assinaturacontrato' = 'c922d3b8-f216-48cb-b1ba-bdfb48782c6d',
    'HandoverContrato' = '56465893-ba50-457e-91f2-69f04845bcbf',
    'EnviaCartaAgradecimento' = '7d084100-9f1d-48fa-a1fd-ab51868c90a3',
    'ConclusaoDoProcessoStep' = 'de0003bd-ee6b-48c3-9aa2-05285203ffb1',

    // 'SolicitacaoParecerTecnico' = '2c5b08d3-8ae4-49c0-b07d-b1aa463ef9ca',
    // 'ConfirmacaodaDataEnvioPropostaComercialProponentes' = '94d9be86-d521-4e7a-a37e-74c7cb2327db',
    // 'RealizacaoChecklistPropostasComerciais' = '981c29ff-dc2c-41b4-8470-b293e97e0c37',    


    'FluxoGenericoRodadaNegociacao' = '9848caa0-d8a2-4d7e-8113-afaa91e6963b',
}


